import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {ensureNotObject, keyify} from "../common";

export function RenderDeleteAccountValueOverrides(props: RendererProps): ReactElement {
    const monthIndexes = props.variables["monthIndexes"];
    if(!Array.isArray(monthIndexes) || monthIndexes.length === 0) {
        return <div>No change</div>;
    }

    return <ul>
        {monthIndexes.map(m => <li key={keyify(m)}>Month {ensureNotObject(m)}: Override Removed</li>)}
    </ul>;
}